import { C } from "../lib/colors";
import { Logo } from "./Logo";

export const PageShell = ({ onNavigate, authRole, children }) => {
  const dashboardPage = authRole === "owner" ? "agents" : authRole === "client" ? "portal" : null;
  const dashboardLabel = authRole === "owner" ? "← Back to Dashboard" : authRole === "client" ? "← Back to Portal" : null;
  return (
  <div style={{background:"#000000",minHeight:"100vh",fontFamily:"'Instrument Sans',sans-serif",color:C.text}}>
    <nav style={{position:"sticky",top:0,zIndex:100,background:"rgba(0,0,0,0.95)",backdropFilter:"blur(20px)",
      borderBottom:`1px solid ${C.border}`,padding:"0 5%",height:96,display:"flex",alignItems:"center",justifyContent:"space-between"}}>
      <button onClick={()=>onNavigate("landing")} style={{background:"none",border:"none",cursor:"pointer"}}><Logo size={44}/></button>
      <button onClick={()=>onNavigate(dashboardPage || "landing")} style={{background:"none",border:"none",color:C.muted,
        fontSize:13,cursor:"pointer",fontFamily:"'Instrument Sans',sans-serif",transition:"color 0.2s"}}
        onMouseEnter={e=>e.target.style.color="#fff"} onMouseLeave={e=>e.target.style.color=C.muted}>
        {dashboardLabel || "← Back to Home"}
      </button>
    </nav>
    {children}
    <footer style={{borderTop:`1px solid ${C.border}`,padding:"32px 5% 28px",marginTop:80}}>
      <div style={{maxWidth:1200,margin:"0 auto",display:"flex",alignItems:"flex-start",
        justifyContent:"space-between",flexWrap:"wrap",gap:24}}>
        {/* Brand block */}
        <div style={{maxWidth:300,minWidth:200}}>
          <div style={{marginBottom:10}}><Logo size={32}/></div>
          <div style={{fontSize:12,color:C.muted,lineHeight:1.55}}>
            Done-for-you content marketing powered by AI agents. Your content drops in 48 hours.
          </div>
        </div>
        {/* Product nav */}
        <nav aria-label="Product" style={{display:"flex",flexDirection:"column",gap:6,minWidth:120}}>
          <div style={{fontSize:10,color:C.muted,fontFamily:"'DM Mono',monospace",
            textTransform:"uppercase",letterSpacing:1.5,marginBottom:6}}>Product</div>
          {[["How It Works","how"],["Pricing","pricing"],["Get Started","onboarding"]].map(([l,p])=>(
            <button key={p} onClick={()=>onNavigate(p)} style={{background:"none",border:"none",
              color:C.muted,fontSize:13,cursor:"pointer",fontFamily:"'Instrument Sans',sans-serif",
              transition:"color 0.2s",textAlign:"left",padding:0}}
              onMouseEnter={e=>e.currentTarget.style.color="#fff"}
              onMouseLeave={e=>e.currentTarget.style.color=C.muted}>{l}</button>
          ))}
        </nav>
        {/* Account nav */}
        <nav aria-label="Account" style={{display:"flex",flexDirection:"column",gap:6,minWidth:120}}>
          <div style={{fontSize:10,color:C.muted,fontFamily:"'DM Mono',monospace",
            textTransform:"uppercase",letterSpacing:1.5,marginBottom:6}}>Account</div>
          {[["Sign In","login"],["Forgot Password","forgot-password"],["Contact Us","contact"]].map(([l,p])=>(
            <button key={p} onClick={()=>onNavigate(p)} style={{background:"none",border:"none",
              color:C.muted,fontSize:13,cursor:"pointer",fontFamily:"'Instrument Sans',sans-serif",
              transition:"color 0.2s",textAlign:"left",padding:0}}
              onMouseEnter={e=>e.currentTarget.style.color="#fff"}
              onMouseLeave={e=>e.currentTarget.style.color=C.muted}>{l}</button>
          ))}
        </nav>
        {/* Legal nav */}
        <nav aria-label="Legal" style={{display:"flex",flexDirection:"column",gap:6,minWidth:120}}>
          <div style={{fontSize:10,color:C.muted,fontFamily:"'DM Mono',monospace",
            textTransform:"uppercase",letterSpacing:1.5,marginBottom:6}}>Legal</div>
          {[["Privacy Policy","privacy"],["Terms of Service","terms"]].map(([l,p])=>(
            <button key={p} onClick={()=>onNavigate(p)} style={{background:"none",border:"none",
              color:C.muted,fontSize:13,cursor:"pointer",fontFamily:"'Instrument Sans',sans-serif",
              transition:"color 0.2s",textAlign:"left",padding:0}}
              onMouseEnter={e=>e.currentTarget.style.color="#fff"}
              onMouseLeave={e=>e.currentTarget.style.color=C.muted}>{l}</button>
          ))}
        </nav>
      </div>
      {/* Copyright line */}
      <div style={{maxWidth:1200,margin:"24px auto 0",paddingTop:18,borderTop:`1px solid ${C.border}`,
        fontSize:11,color:"rgba(255,255,255,0.25)"}}>
        © {new Date().getFullYear()} Media on Auto Pilot — All rights reserved.
      </div>
    </footer>
  </div>
  );
};
